import {
  CREATE_PLAN_BEGIN,
  CREATE_PLAN_SUCCESS,
  CREATE_PLAN_FAILURE,
  FETCH_PLAN_BEGIN,
  FETCH_PLAN_SUCCESS,
  FETCH_PLAN_FAILURE,
  FETCH_PLANS_ANSWERS_BEGIN,
  FETCH_PLANS_ANSWERS_SUCCESS,
  FETCH_PLANS_ANSWERS_FAILURE,
  SAVE_ABOUT_ME_BEGIN,
  SAVE_ABOUT_ME_SUCCESS,
  SAVE_ABOUT_ME_FAILURE,
  SAVE_SUPPORT_TEAM_BEGIN,
  SAVE_SUPPORT_TEAM_SUCCESS,
  SAVE_SUPPORT_TEAM_FAILURE,
  SAVE_COMMUNITY_ACTIVITIES_BEGIN,
  SAVE_COMMUNITY_ACTIVITIES_SUCCESS,
  SAVE_COMMUNITY_ACTIVITIES_FAILURE,
  SAVE_MY_GOALS_BEGIN,
  SAVE_MY_GOALS_SUCCESS,
  SAVE_MY_GOALS_FAILURE,
  SAVE_REQUIRED_SERVICES_BEGIN,
  SAVE_REQUIRED_SERVICES_SUCCESS,
  SAVE_REQUIRED_SERVICES_FAILURE,
  DELETE_SUPPORT_TEAM_BEGIN,
  DELETE_SUPPORT_TEAM_SUCCESS,
  DELETE_SUPPORT_TEAM_FAILURE,
  DELETE_REQUIRED_SERVICES_BEGIN,
  DELETE_REQUIRED_SERVICES_SUCCESS,
  DELETE_REQUIRED_SERVICES_FAILURE,
  FILE_UPLOAD_BEGIN,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_FAILURE,
  FETCH_SUPPORT_REQUEST_BEGIN,
  FETCH_SUPPORT_REQUEST_SUCCESS,
  FETCH_SUPPORT_REQUEST_FAILURE,
  SAVE_SUPPORT_REQUEST_BEGIN,
  SAVE_SUPPORT_REQUEST_SUCCESS,
  SAVE_SUPPORT_REQUEST_FAILURE,
  TOGGLE_ENDORSEMENT_BEGIN,
  TOGGLE_ENDORSEMENT_SUCCESS,
  TOGGLE_ENDORSEMENT_FAILURE,
  ARCHIVE_SUGGESTIONS_BEGIN,
  ARCHIVE_SUGGESTIONS_SUCCESS,
  ARCHIVE_SUGGESTIONS_FAILURE
} from "./actions"

const initialState = {
  loading: true,
  fileUploading: false,
  id: null,
  answers: {},
  supportRequestsLoading: false,
  endorsementLoading: false,
  archiveSuggestionsLoading: false,
  supportRequests: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PLAN_BEGIN:
      return { ...state, loading: true }
    case CREATE_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        id: action.payload.id
      }
    case CREATE_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        id: null
      }

    case FETCH_PLAN_BEGIN:
      return { ...state, loading: true }
    case FETCH_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        id: action.payload.id
      }
    case FETCH_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        id: null
      }

    case FETCH_PLANS_ANSWERS_BEGIN:
      return { ...state, loading: true }
    case FETCH_PLANS_ANSWERS_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: action.payload.answers
      }
    case FETCH_PLANS_ANSWERS_FAILURE:
      return {
        ...state,
        loading: false
      }

    case SAVE_ABOUT_ME_BEGIN:
      return { ...state, loading: true }
    case SAVE_ABOUT_ME_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: {
          ...state.answers,
          aboutMe: action.payload.answers
        }
      }
    case SAVE_ABOUT_ME_FAILURE:
      return {
        ...state,
        loading: false
      }

    case SAVE_SUPPORT_TEAM_BEGIN:
      return { ...state, loading: true }
    case SAVE_SUPPORT_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: {
          ...state.answers,
          supportTeam: action.payload.answers
        }
      }
    case SAVE_SUPPORT_TEAM_FAILURE:
      return {
        ...state,
        loading: false
      }

    case SAVE_COMMUNITY_ACTIVITIES_BEGIN:
      return { ...state, loading: true }
    case SAVE_COMMUNITY_ACTIVITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: {
          ...state.answers,
          communityActivities: action.payload.answers
        }
      }
    case SAVE_COMMUNITY_ACTIVITIES_FAILURE:
      return {
        ...state,
        loading: false
      }

    case SAVE_MY_GOALS_BEGIN:
      return { ...state, loading: true }
    case SAVE_MY_GOALS_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: {
          ...state.answers,
          myGoals: action.payload.answers
        }
      }
    case SAVE_MY_GOALS_FAILURE:
      return {
        ...state,
        loading: false
      }

    case SAVE_REQUIRED_SERVICES_BEGIN:
      return { ...state, loading: true }
    case SAVE_REQUIRED_SERVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: {
          ...state.answers,
          requiredServices: action.payload.answers
        }
      }
    case SAVE_REQUIRED_SERVICES_FAILURE:
      return {
        ...state,
        loading: false
      }

    case DELETE_SUPPORT_TEAM_BEGIN:
      return { ...state, loading: true }
    case DELETE_SUPPORT_TEAM_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: {
          ...state.answers,
          supportTeam: action.payload.answers
        }
      }
    case DELETE_SUPPORT_TEAM_FAILURE:
      return {
        ...state,
        loading: false
      }

    case DELETE_REQUIRED_SERVICES_BEGIN:
      return { ...state, loading: true }
    case DELETE_REQUIRED_SERVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: {
          ...state.answers,
          requiredServices: action.payload.answers
        }
      }
    case DELETE_REQUIRED_SERVICES_FAILURE:
      return {
        ...state,
        loading: false
      }

    case FILE_UPLOAD_BEGIN:
      return { ...state, fileUploading: true }
    case FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        fileUploading: false
      }
    case FILE_UPLOAD_FAILURE:
      return {
        ...state,
        fileUploading: false
      }

    case FETCH_SUPPORT_REQUEST_BEGIN:
      return { ...state, supportRequestsLoading: true }
    case FETCH_SUPPORT_REQUEST_SUCCESS:
      return {
        ...state,
        supportRequestsLoading: false,
        supportRequests: action.payload.requests
      }
    case FETCH_SUPPORT_REQUEST_FAILURE:
      return {
        ...state,
        supportRequestsLoading: false
      }

    case SAVE_SUPPORT_REQUEST_BEGIN:
      return { ...state, supportRequestsLoading: true }
    case SAVE_SUPPORT_REQUEST_SUCCESS:
      return {
        ...state,
        supportRequestsLoading: false
      }
    case SAVE_SUPPORT_REQUEST_FAILURE:
      return {
        ...state,
        supportRequestsLoading: false
      }

    case TOGGLE_ENDORSEMENT_BEGIN:
      return { ...state, endorsementLoading: true }
    case TOGGLE_ENDORSEMENT_SUCCESS:
      return { ...state, endorsementLoading: false }
    case TOGGLE_ENDORSEMENT_FAILURE:
      return { ...state, endorsementLoading: false }

    case ARCHIVE_SUGGESTIONS_BEGIN:
      return { ...state, archiveSuggestionsLoading: true }
    case ARCHIVE_SUGGESTIONS_SUCCESS:
      return { ...state, archiveSuggestionsLoading: false }
    case ARCHIVE_SUGGESTIONS_FAILURE:
      return { ...state, archiveSuggestionsLoading: false }

    default:
      return state
  }
}
